import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'rma-agent-activation',
  imports: [MatProgressSpinnerModule, MatButtonModule],
  templateUrl: './agent-activation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentActivationComponent {
  @Input() profileImageUrl: string | undefined;
  @Input() heading = '';
  @Input() subheading = '';
  @Input() cta = '';
  @Input() termsConditions = '';
  @Input() pending = false;

  @Output() activateProfile: EventEmitter<void> = new EventEmitter<void>();

  onActivateProfile() {
    this.activateProfile.emit();
  }
}
